<script>
    import { metaInfo } from "@/core/MetaInfo";

    export default {
        name: "Vendors",
        data() {
            return {
                list: [],
                modelsList: [],
                versionsList: [],
                isLoading: true,
            };
        },
        mounted() {
            Promise.all([
                this.$store.autoAdminApi.getModels(),
                this.$store.autoAdminApi.getVersions(),
                this.$store.autoAdminApi.getOffers(),
            ]).then((data) => {
                this.modelsList = data[0].data.items;
                this.versionsList = data[1].data.items;
                this.list = data[2].data.items;
                this.isLoading = false;
            });
        },
        methods: {
            selected(item) {
                this.$router.push({ name: "OfferEdit", params: { slug: item.id } });
            },
            // getList() {
            //     this.$store.autoAdminApi.getOffers().then(({ data }) => {
            //         this.list = data.items;
            //         this.isLoading = false;
            //     });
            // },
            getStatus(value) {
                let filtered = {
                    in_stock: "В наличии",
                    ordered: "В резерве",
                    sold: "Продано",
                    eol: "EOL",
                };
                return filtered[value];
            },
            getName({ modelId, versionId }) {
                let nameModel = this.modelsList.find((model) => model.id === modelId).name;
                let nameVersion = this.versionsList.find(
                    (version) => version.id === versionId
                ).name;
                return nameModel + " " + nameVersion;
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <section class="section">
        <div class="field">
            <b-button tag="router-link" to="/offer/new" type="is-primary" outlined>
                Добавить ТП
            </b-button>
        </div>

        <h1 class="title">Список торговых предложения</h1>

        <b-table :data="list" @select="selected" hoverable>
            <b-loading
                v-model="isLoading"
                :can-cancel="true"
                :is-full-page="false"
            ></b-loading>
            <b-table-column
                field="modelId"
                label="Модель и Комплектация"
                sortable
                v-slot="props"
            >
                {{ getName(props.row) }}
            </b-table-column>
            <b-table-column field="status" label="Статус" sortable v-slot="props">
                {{ getStatus(props.row.status) }}
            </b-table-column>
            <b-table-column field="issuedAt" label="Дата выпуска" sortable v-slot="props">
                {{ props.row.issuedAt }}
            </b-table-column>
            <b-table-column field="color" label="Цвет" sortable v-slot="props">
                {{ props.row.color }}
            </b-table-column>
            <b-table-column field="price" label="Цена" sortable v-slot="props">
                {{ props.row.price }}
            </b-table-column>
        </b-table>
    </section>
</template>

<style lang="scss"></style>
